module.exports = __webpack_public_path__ + "img/voucher.cfd27347.svg";